<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding">
          <span class="arch">
            <p>This city is warm, warm and vibrant. </p>
            <p>There is life here. </p>
            <p>There are people. </p>
            <p>The stone that forms buildings, walls and pavements is weathered, pitted and scratched. </p>
            <br>
            <p>This is an old place. </p>
          </span>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A New Place'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
